import React from 'react';
import { compose } from 'recompose';
import { Formik } from 'formik';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import * as actions from './simulatedContentMapActions';
import SimulatedAbilityModalForm from './SimulatedAbilityModalForm';
import AbilityModalType from './simulatedAbilityModalType';
import * as Yup from 'yup';

const AddAbilitySchema = Yup.object().shape({
  idCatalogingDiscipline: Yup.number().required('errorRequired'),
  idCatalogingMatrix: Yup.number().required('errorRequired'),
  contentOrIdMatrixContent: Yup.mixed().required('errorRequired'),
  cataloging: Yup.mixed().required('errorRequired'),
});

function getContentOrIdMatrixContent(ability) {
  if (ability.content) {
    return {
      label: ability.content,
      value: ability.content,
    };
  }
  if (ability.idMatrixContent) {
    return {
      label: ability.matrixContent,
      value: ability.idMatrixContent,
    };
  }
  return {
    label: ability.matrixContent,
    value: ability.matrixContent,
  };
}

function getInitialValues(ability) {
  if (!ability) return {};
  return {
    idAbility: ability.abilityId,
    idCatalogingDiscipline:
      ability.catalogingDiscipline > 0
        ? ability.catalogingDiscipline[0].cc_id
        : ability.idCatalogingDiscipline,
    idCatalogingMatrix: ability.idCatalogingMatrix,
    contentOrIdMatrixContent: getContentOrIdMatrixContent(ability),
    idMatrixContent: ability.idMatrixContent,
    cataloging: ability.oficialCatalogingId
      ? {
          label: ability.oficialCatalogingName,
          value: ability.oficialCatalogingId,
        }
      : undefined,
    catalogingName: ability.schoolAbilityName,
    catalogingDescription: ability.schoolAbilityObservations,
  };
}

const EditStudentModal = props => {
  const initialValues = getInitialValues(props.ability);

  React.useEffect(() => {
    props.getCurricularAbilityOptions({
      idEvaluation: props.idEvaluation,
      catalogingType: 'discipline',
    });
  }, [props.idEvaluation]);

  React.useEffect(() => {
    if (props.ability) {
      if (props.type === 5) {
        props.getUnitsAbilityOptions({
          idEvaluation: props.idEvaluation,
          catalogingType: 'matrix',
          idCatalogingDiscipline: initialValues.idCatalogingDiscipline,
          view: '1',
        });
      } else if (props.type === 2) {
        props.getUnitsAbilityOptions({
          idEvaluation: props.idEvaluation,
          catalogingType: 'matrix',
          idCatalogingDiscipline: initialValues.idCatalogingDiscipline,
          idAlternativeMatrix: props.idAlternativeMatrix,
        });
      } else {
        props.getUnitsAbilityOptions({
          idEvaluation: props.idEvaluation,
          catalogingType: 'matrix',
          idCatalogingDiscipline: initialValues.idCatalogingDiscipline,
        });
      }
    }
  }, [props.ability]);

  const isReadOnly = [
    AbilityModalType.APPROVE,
    AbilityModalType.REPROVE,
    AbilityModalType.VIEW,
  ].includes(props.type);

  return (
    <Formik
      validationSchema={AddAbilitySchema}
      initialValues={{ ...initialValues }}
      enableReinitialize
      render={formProps => (
        <SimulatedAbilityModalForm {...props} {...formProps} readOnly={isReadOnly} />
      )}
    />
  );
};

EditStudentModal.propTypes = {};

const mapStateToProps = ({ simulatedContentMap }) => ({
  ...simulatedContentMap,
});

export default compose(injectIntl, connect(mapStateToProps, { ...actions }))(EditStudentModal);
